webpackJsonp([35783957827783],{

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(93);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(123);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(122);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(282);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(281);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\""; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\""; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _scrollmagic = __webpack_require__(23);
	
	var _stylesModule = __webpack_require__(687);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollDown = (_temp = _class = function (_Component) {
	  _inherits(ScrollDown, _Component);
	
	  function ScrollDown() {
	    _classCallCheck(this, ScrollDown);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ScrollDown.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.animation = new TimelineMax({ paused: true }).set(this.node, { css: { animation: 'none' } }).to(this.node, 2, { y: 60, opacity: 0 });
	
	    this.scene = new _scrollmagic.Scene({ triggerElement: this.node, triggerHook: 0.7 });
	    this.scene.indicatorName = 'ScrollDown';
	    this.scene.on('enter', function () {
	      _this2.animation.play();
	    });
	
	    if (false) {
	      this.scene.addIndicators({ name: this.scene.indicatorName });
	    }
	
	    this.scene.addTo(this.context.scrollmagic);
	  };
	
	  ScrollDown.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.wrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.scrolldown, ref: function ref(c) {
	            _this3.node = c;
	          } },
	        _react2.default.createElement(
	          'p',
	          { className: _stylesModule2.default.scrollText },
	          'Scroll Down'
	        ),
	        _react2.default.createElement(
	          'svg',
	          { className: _stylesModule2.default.svg, viewBox: '0 0 24 24' },
	          _react2.default.createElement('path', { d: 'M6 9l6 6 6-6' })
	        )
	      )
	    );
	  };
	
	  return ScrollDown;
	}(_react.Component), _class.contextTypes = {
	  scrollmagic: _propTypes2.default.any
	}, _temp);
	exports.default = ScrollDown;
	module.exports = exports['default'];

/***/ }),

/***/ 687:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container-fluid":"src-components-Banner-ScrollDown----styles-module---container-fluid---31dpI","row":"src-components-Banner-ScrollDown----styles-module---row---3uoQJ","reverse":"src-components-Banner-ScrollDown----styles-module---reverse---1pNJe","col":"src-components-Banner-ScrollDown----styles-module---col---2dVzH","col-xs":"src-components-Banner-ScrollDown----styles-module---col-xs---2FxyO","col-xs-1":"src-components-Banner-ScrollDown----styles-module---col-xs-1---1rxhr","col-xs-2":"src-components-Banner-ScrollDown----styles-module---col-xs-2---SytEE","col-xs-3":"src-components-Banner-ScrollDown----styles-module---col-xs-3---1fXA6","col-xs-4":"src-components-Banner-ScrollDown----styles-module---col-xs-4---2r-vj","col-xs-5":"src-components-Banner-ScrollDown----styles-module---col-xs-5---t_IDM","col-xs-6":"src-components-Banner-ScrollDown----styles-module---col-xs-6---CTZUA","col-xs-7":"src-components-Banner-ScrollDown----styles-module---col-xs-7---1dyTC","col-xs-8":"src-components-Banner-ScrollDown----styles-module---col-xs-8---2z6il","col-xs-9":"src-components-Banner-ScrollDown----styles-module---col-xs-9---2zrwT","col-xs-10":"src-components-Banner-ScrollDown----styles-module---col-xs-10---2KEc0","col-xs-11":"src-components-Banner-ScrollDown----styles-module---col-xs-11---3vOKN","col-xs-12":"src-components-Banner-ScrollDown----styles-module---col-xs-12---3-J-E","col-xs-offset-1":"src-components-Banner-ScrollDown----styles-module---col-xs-offset-1---3mX3i","col-xs-offset-2":"src-components-Banner-ScrollDown----styles-module---col-xs-offset-2---2ac3k","col-xs-offset-3":"src-components-Banner-ScrollDown----styles-module---col-xs-offset-3---1guy9","col-xs-offset-4":"src-components-Banner-ScrollDown----styles-module---col-xs-offset-4---22aWB","col-xs-offset-5":"src-components-Banner-ScrollDown----styles-module---col-xs-offset-5---38sLu","col-xs-offset-6":"src-components-Banner-ScrollDown----styles-module---col-xs-offset-6---KrL5n","col-xs-offset-7":"src-components-Banner-ScrollDown----styles-module---col-xs-offset-7---3gQu1","col-xs-offset-8":"src-components-Banner-ScrollDown----styles-module---col-xs-offset-8---2mHcN","col-xs-offset-9":"src-components-Banner-ScrollDown----styles-module---col-xs-offset-9---3IPZB","col-xs-offset-10":"src-components-Banner-ScrollDown----styles-module---col-xs-offset-10---1lGOK","col-xs-offset-11":"src-components-Banner-ScrollDown----styles-module---col-xs-offset-11---3A5OL","start-xs":"src-components-Banner-ScrollDown----styles-module---start-xs---1Sfl8","center-xs":"src-components-Banner-ScrollDown----styles-module---center-xs---3PAWf","end-xs":"src-components-Banner-ScrollDown----styles-module---end-xs---1WbgC","top-xs":"src-components-Banner-ScrollDown----styles-module---top-xs---1Qohn","middle-xs":"src-components-Banner-ScrollDown----styles-module---middle-xs---28ro7","bottom-xs":"src-components-Banner-ScrollDown----styles-module---bottom-xs---3ELp0","around-xs":"src-components-Banner-ScrollDown----styles-module---around-xs---jlonR","between-xs":"src-components-Banner-ScrollDown----styles-module---between-xs---2CBoy","first-xs":"src-components-Banner-ScrollDown----styles-module---first-xs---3J5Am","last-xs":"src-components-Banner-ScrollDown----styles-module---last-xs---1NCDO","container":"src-components-Banner-ScrollDown----styles-module---container---Knnrc","col-sm":"src-components-Banner-ScrollDown----styles-module---col-sm---1R2Y3","col-sm-1":"src-components-Banner-ScrollDown----styles-module---col-sm-1---2RleX","col-sm-2":"src-components-Banner-ScrollDown----styles-module---col-sm-2---3vR4K","col-sm-3":"src-components-Banner-ScrollDown----styles-module---col-sm-3---2nKem","col-sm-4":"src-components-Banner-ScrollDown----styles-module---col-sm-4---2oaXQ","col-sm-5":"src-components-Banner-ScrollDown----styles-module---col-sm-5---5UXpU","col-sm-6":"src-components-Banner-ScrollDown----styles-module---col-sm-6---2Hn11","col-sm-7":"src-components-Banner-ScrollDown----styles-module---col-sm-7---3qvKN","col-sm-8":"src-components-Banner-ScrollDown----styles-module---col-sm-8---2AJ3E","col-sm-9":"src-components-Banner-ScrollDown----styles-module---col-sm-9---1lpbS","col-sm-10":"src-components-Banner-ScrollDown----styles-module---col-sm-10---bNS_B","col-sm-11":"src-components-Banner-ScrollDown----styles-module---col-sm-11---1PUTO","col-sm-12":"src-components-Banner-ScrollDown----styles-module---col-sm-12---4IkDr","col-sm-offset-1":"src-components-Banner-ScrollDown----styles-module---col-sm-offset-1---nplv1","col-sm-offset-2":"src-components-Banner-ScrollDown----styles-module---col-sm-offset-2---3l8qw","col-sm-offset-3":"src-components-Banner-ScrollDown----styles-module---col-sm-offset-3---37FZz","col-sm-offset-4":"src-components-Banner-ScrollDown----styles-module---col-sm-offset-4---2rS4T","col-sm-offset-5":"src-components-Banner-ScrollDown----styles-module---col-sm-offset-5---2zgTq","col-sm-offset-6":"src-components-Banner-ScrollDown----styles-module---col-sm-offset-6---JVUUL","col-sm-offset-7":"src-components-Banner-ScrollDown----styles-module---col-sm-offset-7---2XjFK","col-sm-offset-8":"src-components-Banner-ScrollDown----styles-module---col-sm-offset-8---1HFOV","col-sm-offset-9":"src-components-Banner-ScrollDown----styles-module---col-sm-offset-9---1orc8","col-sm-offset-10":"src-components-Banner-ScrollDown----styles-module---col-sm-offset-10---2h2cR","col-sm-offset-11":"src-components-Banner-ScrollDown----styles-module---col-sm-offset-11---1VoMc","start-sm":"src-components-Banner-ScrollDown----styles-module---start-sm---16b7z","center-sm":"src-components-Banner-ScrollDown----styles-module---center-sm---4ngjn","end-sm":"src-components-Banner-ScrollDown----styles-module---end-sm---rpHsU","top-sm":"src-components-Banner-ScrollDown----styles-module---top-sm---19OYC","middle-sm":"src-components-Banner-ScrollDown----styles-module---middle-sm---ZKkl8","bottom-sm":"src-components-Banner-ScrollDown----styles-module---bottom-sm---2PBus","around-sm":"src-components-Banner-ScrollDown----styles-module---around-sm---zODQu","between-sm":"src-components-Banner-ScrollDown----styles-module---between-sm---3Stct","first-sm":"src-components-Banner-ScrollDown----styles-module---first-sm---2mahy","last-sm":"src-components-Banner-ScrollDown----styles-module---last-sm---b4dtM","col-md":"src-components-Banner-ScrollDown----styles-module---col-md---PIWDp","col-md-1":"src-components-Banner-ScrollDown----styles-module---col-md-1---394RX","col-md-2":"src-components-Banner-ScrollDown----styles-module---col-md-2---37P9Q","col-md-3":"src-components-Banner-ScrollDown----styles-module---col-md-3---3QHxS","col-md-4":"src-components-Banner-ScrollDown----styles-module---col-md-4---3jtk-","col-md-5":"src-components-Banner-ScrollDown----styles-module---col-md-5---3iL20","col-md-6":"src-components-Banner-ScrollDown----styles-module---col-md-6---edi0f","col-md-7":"src-components-Banner-ScrollDown----styles-module---col-md-7---1OLo4","col-md-8":"src-components-Banner-ScrollDown----styles-module---col-md-8---1TmVZ","col-md-9":"src-components-Banner-ScrollDown----styles-module---col-md-9---3NOoa","col-md-10":"src-components-Banner-ScrollDown----styles-module---col-md-10---3ONF_","col-md-11":"src-components-Banner-ScrollDown----styles-module---col-md-11---iTySd","col-md-12":"src-components-Banner-ScrollDown----styles-module---col-md-12---mVAek","col-md-offset-1":"src-components-Banner-ScrollDown----styles-module---col-md-offset-1---1fK6K","col-md-offset-2":"src-components-Banner-ScrollDown----styles-module---col-md-offset-2---14DSe","col-md-offset-3":"src-components-Banner-ScrollDown----styles-module---col-md-offset-3---25sA5","col-md-offset-4":"src-components-Banner-ScrollDown----styles-module---col-md-offset-4---3d4qo","col-md-offset-5":"src-components-Banner-ScrollDown----styles-module---col-md-offset-5---bK99a","col-md-offset-6":"src-components-Banner-ScrollDown----styles-module---col-md-offset-6---vP99q","col-md-offset-7":"src-components-Banner-ScrollDown----styles-module---col-md-offset-7---2rc3M","col-md-offset-8":"src-components-Banner-ScrollDown----styles-module---col-md-offset-8---2xJVz","col-md-offset-9":"src-components-Banner-ScrollDown----styles-module---col-md-offset-9---rXXa5","col-md-offset-10":"src-components-Banner-ScrollDown----styles-module---col-md-offset-10---3Ef4A","col-md-offset-11":"src-components-Banner-ScrollDown----styles-module---col-md-offset-11---6Z7V2","start-md":"src-components-Banner-ScrollDown----styles-module---start-md---2e2ZS","center-md":"src-components-Banner-ScrollDown----styles-module---center-md---2zbsb","end-md":"src-components-Banner-ScrollDown----styles-module---end-md---2QulB","top-md":"src-components-Banner-ScrollDown----styles-module---top-md---28Fm_","middle-md":"src-components-Banner-ScrollDown----styles-module---middle-md---27Ezz","bottom-md":"src-components-Banner-ScrollDown----styles-module---bottom-md---3TQLB","around-md":"src-components-Banner-ScrollDown----styles-module---around-md---1STOR","between-md":"src-components-Banner-ScrollDown----styles-module---between-md---3GorF","first-md":"src-components-Banner-ScrollDown----styles-module---first-md---1CpPf","last-md":"src-components-Banner-ScrollDown----styles-module---last-md---21qFq","col-lg":"src-components-Banner-ScrollDown----styles-module---col-lg---1lOcY","col-lg-1":"src-components-Banner-ScrollDown----styles-module---col-lg-1---rpdn5","col-lg-2":"src-components-Banner-ScrollDown----styles-module---col-lg-2---2ehcQ","col-lg-3":"src-components-Banner-ScrollDown----styles-module---col-lg-3---k0JjT","col-lg-4":"src-components-Banner-ScrollDown----styles-module---col-lg-4---2ieEi","col-lg-5":"src-components-Banner-ScrollDown----styles-module---col-lg-5---2ckQy","col-lg-6":"src-components-Banner-ScrollDown----styles-module---col-lg-6---26Hkv","col-lg-7":"src-components-Banner-ScrollDown----styles-module---col-lg-7---3WEa_","col-lg-8":"src-components-Banner-ScrollDown----styles-module---col-lg-8---3HTH9","col-lg-9":"src-components-Banner-ScrollDown----styles-module---col-lg-9---3IGo1","col-lg-10":"src-components-Banner-ScrollDown----styles-module---col-lg-10---39t9X","col-lg-11":"src-components-Banner-ScrollDown----styles-module---col-lg-11---3k6fF","col-lg-12":"src-components-Banner-ScrollDown----styles-module---col-lg-12---1Xl6W","col-lg-offset-1":"src-components-Banner-ScrollDown----styles-module---col-lg-offset-1---2lXxO","col-lg-offset-2":"src-components-Banner-ScrollDown----styles-module---col-lg-offset-2---3XTEI","col-lg-offset-3":"src-components-Banner-ScrollDown----styles-module---col-lg-offset-3---I7M3b","col-lg-offset-4":"src-components-Banner-ScrollDown----styles-module---col-lg-offset-4---2hKC5","col-lg-offset-5":"src-components-Banner-ScrollDown----styles-module---col-lg-offset-5---1mFKO","col-lg-offset-6":"src-components-Banner-ScrollDown----styles-module---col-lg-offset-6---Ium8s","col-lg-offset-7":"src-components-Banner-ScrollDown----styles-module---col-lg-offset-7---3oGJH","col-lg-offset-8":"src-components-Banner-ScrollDown----styles-module---col-lg-offset-8---130Lk","col-lg-offset-9":"src-components-Banner-ScrollDown----styles-module---col-lg-offset-9---1zIAM","col-lg-offset-10":"src-components-Banner-ScrollDown----styles-module---col-lg-offset-10---1gMOH","col-lg-offset-11":"src-components-Banner-ScrollDown----styles-module---col-lg-offset-11---2zqOs","start-lg":"src-components-Banner-ScrollDown----styles-module---start-lg---3tmeJ","center-lg":"src-components-Banner-ScrollDown----styles-module---center-lg---2BJl6","end-lg":"src-components-Banner-ScrollDown----styles-module---end-lg---1JQlY","top-lg":"src-components-Banner-ScrollDown----styles-module---top-lg---1P79Q","middle-lg":"src-components-Banner-ScrollDown----styles-module---middle-lg---1ZStS","bottom-lg":"src-components-Banner-ScrollDown----styles-module---bottom-lg---39krF","around-lg":"src-components-Banner-ScrollDown----styles-module---around-lg---teckF","between-lg":"src-components-Banner-ScrollDown----styles-module---between-lg---2Vapq","first-lg":"src-components-Banner-ScrollDown----styles-module---first-lg---25uVV","last-lg":"src-components-Banner-ScrollDown----styles-module---last-lg---1hcV0","menu-list":"src-components-Banner-ScrollDown----styles-module---menu-list---25nV5","menu-link":"src-components-Banner-ScrollDown----styles-module---menu-link---22nkm","underLine-container":"src-components-Banner-ScrollDown----styles-module---underLine-container---32i_L","hero":"src-components-Banner-ScrollDown----styles-module---hero---WpiVh","hero__content":"src-components-Banner-ScrollDown----styles-module---hero__content---3Rzaa","hero_title":"src-components-Banner-ScrollDown----styles-module---hero_title---2l39a","hero__list-line":"src-components-Banner-ScrollDown----styles-module---hero__list-line---3WhS0","hero__list":"src-components-Banner-ScrollDown----styles-module---hero__list---1isc1","hero__list-item":"src-components-Banner-ScrollDown----styles-module---hero__list-item---36TPM","std-header__bg-wrap":"src-components-Banner-ScrollDown----styles-module---std-header__bg-wrap---2NUu-","std-header__bg":"src-components-Banner-ScrollDown----styles-module---std-header__bg---3QwW5","home--section-bar":"src-components-Banner-ScrollDown----styles-module---home--section-bar---2xMP4","home-recent--project":"src-components-Banner-ScrollDown----styles-module---home-recent--project---1cqAa","home-recent--project--image":"src-components-Banner-ScrollDown----styles-module---home-recent--project--image---3WwEo","home-recent--project--image--con":"src-components-Banner-ScrollDown----styles-module---home-recent--project--image--con---2bSy0","home-recent--project--image--bg":"src-components-Banner-ScrollDown----styles-module---home-recent--project--image--bg---1bN77","home-recent--project--details-wrap":"src-components-Banner-ScrollDown----styles-module---home-recent--project--details-wrap---zUjZ1","home-recent--project--details--name":"src-components-Banner-ScrollDown----styles-module---home-recent--project--details--name---2YDFm","home-recent--project--details--type":"src-components-Banner-ScrollDown----styles-module---home-recent--project--details--type---3uHwN","home-recent--project--details--para":"src-components-Banner-ScrollDown----styles-module---home-recent--project--details--para---1EgB6","cs-home-about--text":"src-components-Banner-ScrollDown----styles-module---cs-home-about--text---3Z4A0","cur-next-slide":"src-components-Banner-ScrollDown----styles-module---cur-next-slide---3bflP","wrapper":"src-components-Banner-ScrollDown----styles-module---wrapper---eXpJ5","scrolldown":"src-components-Banner-ScrollDown----styles-module---scrolldown---3pvoS","pulse":"src-components-Banner-ScrollDown----styles-module---pulse---1qXKr","scrollText":"src-components-Banner-ScrollDown----styles-module---scrollText---2J77_","svg":"src-components-Banner-ScrollDown----styles-module---svg---3VtL0"};

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Banner;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(711);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _stylesModule = __webpack_require__(688);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _ScrollDown = __webpack_require__(370);
	
	var _ScrollDown2 = _interopRequireDefault(_ScrollDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Banner(_ref) {
	  var children = _ref.children,
	      sizes = _ref.sizes;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.wrapper },
	      _react2.default.createElement(_gatsbyImage2.default, {
	        className: _stylesModule2.default.image,
	        sizes: sizes,
	        style: { position: 'absolute', zIndex: '-1' }
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.container },
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.content },
	          children
	        )
	      )
	    ),
	    _react2.default.createElement(_ScrollDown2.default, null)
	  );
	}
	
	Banner.propTypes = {
	  children: _propTypes2.default.any,
	  sizes: _propTypes2.default.object
	};
	module.exports = exports['default'];

/***/ }),

/***/ 688:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container-fluid":"src-components-Banner----styles-module---container-fluid---ZQK4T","row":"src-components-Banner----styles-module---row---1fPwY","reverse":"src-components-Banner----styles-module---reverse---1unAP","col":"src-components-Banner----styles-module---col---9KxSy","col-xs":"src-components-Banner----styles-module---col-xs---2EgkD","col-xs-1":"src-components-Banner----styles-module---col-xs-1---1UrRW","col-xs-2":"src-components-Banner----styles-module---col-xs-2---2VZBf","col-xs-3":"src-components-Banner----styles-module---col-xs-3---3W3xU","col-xs-4":"src-components-Banner----styles-module---col-xs-4---k0ayJ","col-xs-5":"src-components-Banner----styles-module---col-xs-5---rbSh8","col-xs-6":"src-components-Banner----styles-module---col-xs-6---NpyOJ","col-xs-7":"src-components-Banner----styles-module---col-xs-7---1H0L8","col-xs-8":"src-components-Banner----styles-module---col-xs-8---L5T_K","col-xs-9":"src-components-Banner----styles-module---col-xs-9---ZvPLp","col-xs-10":"src-components-Banner----styles-module---col-xs-10---22Mxs","col-xs-11":"src-components-Banner----styles-module---col-xs-11---1BKUr","col-xs-12":"src-components-Banner----styles-module---col-xs-12---dl4Z2","col-xs-offset-1":"src-components-Banner----styles-module---col-xs-offset-1---atO21","col-xs-offset-2":"src-components-Banner----styles-module---col-xs-offset-2---1B9n6","col-xs-offset-3":"src-components-Banner----styles-module---col-xs-offset-3---35YN7","col-xs-offset-4":"src-components-Banner----styles-module---col-xs-offset-4---8b1VU","col-xs-offset-5":"src-components-Banner----styles-module---col-xs-offset-5---7R4sK","col-xs-offset-6":"src-components-Banner----styles-module---col-xs-offset-6---typSd","col-xs-offset-7":"src-components-Banner----styles-module---col-xs-offset-7---1iyQG","col-xs-offset-8":"src-components-Banner----styles-module---col-xs-offset-8---1BkOt","col-xs-offset-9":"src-components-Banner----styles-module---col-xs-offset-9---2KZv6","col-xs-offset-10":"src-components-Banner----styles-module---col-xs-offset-10---1WRr1","col-xs-offset-11":"src-components-Banner----styles-module---col-xs-offset-11---3lNeK","start-xs":"src-components-Banner----styles-module---start-xs---26G00","center-xs":"src-components-Banner----styles-module---center-xs---3zzil","end-xs":"src-components-Banner----styles-module---end-xs---2i5Ah","top-xs":"src-components-Banner----styles-module---top-xs---2hXon","middle-xs":"src-components-Banner----styles-module---middle-xs---3kmBJ","bottom-xs":"src-components-Banner----styles-module---bottom-xs---LO1WZ","around-xs":"src-components-Banner----styles-module---around-xs---3SqA-","between-xs":"src-components-Banner----styles-module---between-xs---24uKL","first-xs":"src-components-Banner----styles-module---first-xs---2iSqF","last-xs":"src-components-Banner----styles-module---last-xs---31ImE","container":"src-components-Banner----styles-module---container---1VTtb","col-sm":"src-components-Banner----styles-module---col-sm---3fSC2","col-sm-1":"src-components-Banner----styles-module---col-sm-1---1eJ97","col-sm-2":"src-components-Banner----styles-module---col-sm-2---3ifae","col-sm-3":"src-components-Banner----styles-module---col-sm-3---2R1bf","col-sm-4":"src-components-Banner----styles-module---col-sm-4---1lZgb","col-sm-5":"src-components-Banner----styles-module---col-sm-5---21gWz","col-sm-6":"src-components-Banner----styles-module---col-sm-6---XBAoO","col-sm-7":"src-components-Banner----styles-module---col-sm-7---ORiOy","col-sm-8":"src-components-Banner----styles-module---col-sm-8---3CIVR","col-sm-9":"src-components-Banner----styles-module---col-sm-9---1ogfe","col-sm-10":"src-components-Banner----styles-module---col-sm-10---YeLSF","col-sm-11":"src-components-Banner----styles-module---col-sm-11---2dxOk","col-sm-12":"src-components-Banner----styles-module---col-sm-12---1YALo","col-sm-offset-1":"src-components-Banner----styles-module---col-sm-offset-1---1zztN","col-sm-offset-2":"src-components-Banner----styles-module---col-sm-offset-2---3xk-q","col-sm-offset-3":"src-components-Banner----styles-module---col-sm-offset-3---1LGKG","col-sm-offset-4":"src-components-Banner----styles-module---col-sm-offset-4---9mjp-","col-sm-offset-5":"src-components-Banner----styles-module---col-sm-offset-5---24mBM","col-sm-offset-6":"src-components-Banner----styles-module---col-sm-offset-6---2w2-k","col-sm-offset-7":"src-components-Banner----styles-module---col-sm-offset-7---2L-ir","col-sm-offset-8":"src-components-Banner----styles-module---col-sm-offset-8---3V8ZS","col-sm-offset-9":"src-components-Banner----styles-module---col-sm-offset-9---ehjKf","col-sm-offset-10":"src-components-Banner----styles-module---col-sm-offset-10---2VjjV","col-sm-offset-11":"src-components-Banner----styles-module---col-sm-offset-11---2dGvy","start-sm":"src-components-Banner----styles-module---start-sm---1zxXL","center-sm":"src-components-Banner----styles-module---center-sm---2wjuK","end-sm":"src-components-Banner----styles-module---end-sm---2-5et","top-sm":"src-components-Banner----styles-module---top-sm---3-Cab","middle-sm":"src-components-Banner----styles-module---middle-sm---3JpNM","bottom-sm":"src-components-Banner----styles-module---bottom-sm---1F6Px","around-sm":"src-components-Banner----styles-module---around-sm---1IMWQ","between-sm":"src-components-Banner----styles-module---between-sm---31VZj","first-sm":"src-components-Banner----styles-module---first-sm---1QJZD","last-sm":"src-components-Banner----styles-module---last-sm---3nByH","col-md":"src-components-Banner----styles-module---col-md---65xC5","col-md-1":"src-components-Banner----styles-module---col-md-1---2RLhK","col-md-2":"src-components-Banner----styles-module---col-md-2---2zzx7","col-md-3":"src-components-Banner----styles-module---col-md-3---1B6UO","col-md-4":"src-components-Banner----styles-module---col-md-4---1atOM","col-md-5":"src-components-Banner----styles-module---col-md-5---1UMMR","col-md-6":"src-components-Banner----styles-module---col-md-6---1oMW2","col-md-7":"src-components-Banner----styles-module---col-md-7---Oz7c4","col-md-8":"src-components-Banner----styles-module---col-md-8---3Gizs","col-md-9":"src-components-Banner----styles-module---col-md-9---3hFMg","col-md-10":"src-components-Banner----styles-module---col-md-10---YNMYK","col-md-11":"src-components-Banner----styles-module---col-md-11---2Jn_1","col-md-12":"src-components-Banner----styles-module---col-md-12---OCGIN","col-md-offset-1":"src-components-Banner----styles-module---col-md-offset-1---3TVf6","col-md-offset-2":"src-components-Banner----styles-module---col-md-offset-2---30BKE","col-md-offset-3":"src-components-Banner----styles-module---col-md-offset-3---3h9a2","col-md-offset-4":"src-components-Banner----styles-module---col-md-offset-4---1Y_8_","col-md-offset-5":"src-components-Banner----styles-module---col-md-offset-5---oibJD","col-md-offset-6":"src-components-Banner----styles-module---col-md-offset-6---1kyQo","col-md-offset-7":"src-components-Banner----styles-module---col-md-offset-7---23DuW","col-md-offset-8":"src-components-Banner----styles-module---col-md-offset-8---2whbu","col-md-offset-9":"src-components-Banner----styles-module---col-md-offset-9---3Uk-d","col-md-offset-10":"src-components-Banner----styles-module---col-md-offset-10---26dJn","col-md-offset-11":"src-components-Banner----styles-module---col-md-offset-11---21K1r","start-md":"src-components-Banner----styles-module---start-md---vez9U","center-md":"src-components-Banner----styles-module---center-md---38tQL","end-md":"src-components-Banner----styles-module---end-md---3X0vn","top-md":"src-components-Banner----styles-module---top-md---CT3tz","middle-md":"src-components-Banner----styles-module---middle-md---3ObtE","bottom-md":"src-components-Banner----styles-module---bottom-md---21q7T","around-md":"src-components-Banner----styles-module---around-md---2ZdWl","between-md":"src-components-Banner----styles-module---between-md---1yP6f","first-md":"src-components-Banner----styles-module---first-md---38jMr","last-md":"src-components-Banner----styles-module---last-md---39sBj","col-lg":"src-components-Banner----styles-module---col-lg---E5k_E","col-lg-1":"src-components-Banner----styles-module---col-lg-1---1KPfr","col-lg-2":"src-components-Banner----styles-module---col-lg-2---2K7xD","col-lg-3":"src-components-Banner----styles-module---col-lg-3---ltbk1","col-lg-4":"src-components-Banner----styles-module---col-lg-4---39d_d","col-lg-5":"src-components-Banner----styles-module---col-lg-5---39fuU","col-lg-6":"src-components-Banner----styles-module---col-lg-6---3NrJf","col-lg-7":"src-components-Banner----styles-module---col-lg-7---dbjPr","col-lg-8":"src-components-Banner----styles-module---col-lg-8---2aZqy","col-lg-9":"src-components-Banner----styles-module---col-lg-9---1waVV","col-lg-10":"src-components-Banner----styles-module---col-lg-10---1RWgv","col-lg-11":"src-components-Banner----styles-module---col-lg-11---2oci8","col-lg-12":"src-components-Banner----styles-module---col-lg-12---1xOkb","col-lg-offset-1":"src-components-Banner----styles-module---col-lg-offset-1---5eE7k","col-lg-offset-2":"src-components-Banner----styles-module---col-lg-offset-2---2kYUX","col-lg-offset-3":"src-components-Banner----styles-module---col-lg-offset-3---3RF5Z","col-lg-offset-4":"src-components-Banner----styles-module---col-lg-offset-4---YG2bD","col-lg-offset-5":"src-components-Banner----styles-module---col-lg-offset-5---2gvkJ","col-lg-offset-6":"src-components-Banner----styles-module---col-lg-offset-6---3IBXT","col-lg-offset-7":"src-components-Banner----styles-module---col-lg-offset-7---2ZHa0","col-lg-offset-8":"src-components-Banner----styles-module---col-lg-offset-8---3Tubk","col-lg-offset-9":"src-components-Banner----styles-module---col-lg-offset-9---10ZCX","col-lg-offset-10":"src-components-Banner----styles-module---col-lg-offset-10---3L87a","col-lg-offset-11":"src-components-Banner----styles-module---col-lg-offset-11---3sFKX","start-lg":"src-components-Banner----styles-module---start-lg---21E5L","center-lg":"src-components-Banner----styles-module---center-lg---3xh_R","end-lg":"src-components-Banner----styles-module---end-lg---9ZjLS","top-lg":"src-components-Banner----styles-module---top-lg---3QkM3","middle-lg":"src-components-Banner----styles-module---middle-lg---3pSlr","bottom-lg":"src-components-Banner----styles-module---bottom-lg---2yser","around-lg":"src-components-Banner----styles-module---around-lg---3wExv","between-lg":"src-components-Banner----styles-module---between-lg---3xpr6","first-lg":"src-components-Banner----styles-module---first-lg---1Aufo","last-lg":"src-components-Banner----styles-module---last-lg---Xp3o5","menu-list":"src-components-Banner----styles-module---menu-list---1CmYx","menu-link":"src-components-Banner----styles-module---menu-link---o63nc","underLine-container":"src-components-Banner----styles-module---underLine-container---VgGir","hero":"src-components-Banner----styles-module---hero---1Wpds","hero__content":"src-components-Banner----styles-module---hero__content---3Q_s9","hero_title":"src-components-Banner----styles-module---hero_title---2HIAt","hero__list-line":"src-components-Banner----styles-module---hero__list-line---1mpJD","hero__list":"src-components-Banner----styles-module---hero__list---GSkKF","hero__list-item":"src-components-Banner----styles-module---hero__list-item---2b_WC","std-header__bg-wrap":"src-components-Banner----styles-module---std-header__bg-wrap---1sCfI","std-header__bg":"src-components-Banner----styles-module---std-header__bg---2Q2RQ","home--section-bar":"src-components-Banner----styles-module---home--section-bar---9hZip","home-recent--project":"src-components-Banner----styles-module---home-recent--project---XQmFo","home-recent--project--image":"src-components-Banner----styles-module---home-recent--project--image---1zLxY","home-recent--project--image--con":"src-components-Banner----styles-module---home-recent--project--image--con---1QXDS","home-recent--project--image--bg":"src-components-Banner----styles-module---home-recent--project--image--bg---22HR_","home-recent--project--details-wrap":"src-components-Banner----styles-module---home-recent--project--details-wrap---181aE","home-recent--project--details--name":"src-components-Banner----styles-module---home-recent--project--details--name---2nmxb","home-recent--project--details--type":"src-components-Banner----styles-module---home-recent--project--details--type---oeYE3","home-recent--project--details--para":"src-components-Banner----styles-module---home-recent--project--details--para---1v3MM","cs-home-about--text":"src-components-Banner----styles-module---cs-home-about--text---11hbw","cur-next-slide":"src-components-Banner----styles-module---cur-next-slide---1K4RF","wrapper":"src-components-Banner----styles-module---wrapper---190u-","image":"src-components-Banner----styles-module---image---DySC1"};

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gsap = __webpack_require__(39);
	
	var _scrollmagic = __webpack_require__(23);
	
	var _scrollmagic2 = _interopRequireDefault(_scrollmagic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//require('ScrollMagicGSAP');
	//import ScrollMagic from '../../ScrollMagic';
	var componentName = function (_Component) {
	    _inherits(componentName, _Component);
	
	    function componentName() {
	        _classCallCheck(this, componentName);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    componentName.prototype.componentDidMount = function componentDidMount() {
	        var controller = new _scrollmagic2.default.Controller({
	            globalSceneOptions: {
	
	                addIndicators: true
	            }
	        });
	
	        _gsap.TweenMax.set(this.divProjectImageCon, {
	            transformPerspective: 900
	        });
	
	        /*
	        .to(this.divProjectImageCon, 1, {
	          webkitClipPath: 'inset(0% 0%)',
	          clipPath: 'inset(0% 0%)',
	          opacity:1,
	          left:'60px',
	          ease: Power2.easeOut,
	        })
	        */
	
	        var tm = new _gsap.TimelineMax();
	        tm.from(this.divProjectImageCon, 1, {
	            rotationX: 20,
	            transformOrigin: "center top",
	            ease: _gsap.Power2.easeOut
	        }).to(this.divProjectImageBg, 0.6, {
	            opacity: 1,
	            ease: _gsap.Power2.easeOut,
	
	            left: '140px'
	        });
	
	        new _scrollmagic2.default.Scene({
	            triggerElement: this.divCon,
	            triggerHook: 'onEnter',
	            duration: "0%"
	        }).setTween(tm).addTo(controller);
	    };
	
	    componentName.prototype.render = function render() {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'home-recent--project', style: { flexDirection: this.props.oppsiteStyle ? 'row-reverse' : 'row' }, ref: function ref(e) {
	                    return _this2.divCon = e;
	                } },
	            _react2.default.createElement(
	                'div',
	                { className: 'home-recent--project--image' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'home-recent--project--image--con', ref: function ref(e) {
	                            return _this2.divProjectImageCon = e;
	                        } },
	                    _react2.default.createElement('img', { src: 'http://studiogritt.com/media/gallery/7_NTZEMeC.jpg' })
	                ),
	                _react2.default.createElement('div', { className: 'home-recent--project--image--bg', ref: function ref(e) {
	                        return _this2.divProjectImageBg = e;
	                    } })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'home-recent--project--details-wrap' },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'home-recent--project--details--name' },
	                        'Media IQ'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'home-recent--project--details--type' },
	                        'Interiors and Construction'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'home-recent--project--details--para' },
	                        'You may also be interested in react-transition-group-plus, a drop-in replacement for ReactTransitionGroup that allows interruptible transitions and specifying transition order. See a comparative demo here.'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { marginTop: '42px' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'sg-button' },
	                            'SEE THIS STORY'
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return componentName;
	}(_react.Component);
	
	exports.default = componentName;
	module.exports = exports['default'];

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(885);
	
	var _gsap = __webpack_require__(39);
	
	var _SGButton = __webpack_require__(417);
	
	var _SGButton2 = _interopRequireDefault(_SGButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var data = [{
	    id: 0,
	    name: 'Media IQ',
	    des: 'Situated on the corner of Lavelle Road, in plain view of UB City, this exciting space provides the perfect balance of openness and privacy. Spread out over 24000 sft., the office has one floor for conference rooms, a library, an amphitheater and dining area while a separate floor for workstations ensures maximum productivity.',
	    src: 'https://basicagency.com/imager/uploads/case-studies/Fender-Academy/6477/Fender-Academy-Bassbreaker-Cover-Image-01B_974bba97ebdbfe38c7c6078ece6f6a17.jpg 600w, https://basicagency.com/imager/uploads/case-studies/Fender-Academy/6477/Fender-Academy-Bassbreaker-Cover-Image-01B_877de50699a08295026869680339ca47.jpg 940w, https://basicagency.com/imager/uploads/case-studies/Fender-Academy/6477/Fender-Academy-Bassbreaker-Cover-Image-01B_fd86a370f71d27f380250b12fd5f1b14.jpg 1280w, https://basicagency.com/imager/uploads/case-studies/Fender-Academy/6477/Fender-Academy-Bassbreaker-Cover-Image-01B_b0c80ca03ba713639113a0034ddf0313.jpg 2000w'
	}, {
	    id: 1,
	    name: 'Innov8 Coworking Noida',
	    des: 'Innov8 enters Bombay with a small space that speaks fun and life. The centre at Boston tower covers a little over 6000 sqft with a cafe in the terrace space. We are slowly evolving the design language of Innov8 as we move forward. The space consists of well balanced private offices, co-working space and nicely proportioned common areas. ',
	    src: 'https://basicagency.com/imager/uploads/case-studies/Chrome/4896/Vernor_ChromeFamilia-6163_974bba97ebdbfe38c7c6078ece6f6a17.jpg 600w, https://basicagency.com/imager/uploads/case-studies/Chrome/4896/Vernor_ChromeFamilia-6163_877de50699a08295026869680339ca47.jpg 940w, https://basicagency.com/imager/uploads/case-studies/Chrome/4896/Vernor_ChromeFamilia-6163_fd86a370f71d27f380250b12fd5f1b14.jpg 1280w, https://basicagency.com/imager/uploads/case-studies/Chrome/4896/Vernor_ChromeFamilia-6163_b0c80ca03ba713639113a0034ddf0313.jpg 2000w'
	}, {
	    id: 2,
	    name: 'Lol',
	    des: 'something',
	    src: 'https://basicagency.com/imager/uploads/case-studies/BB-Dakota/6473/BB-Dakota-Cover-Image-02_974bba97ebdbfe38c7c6078ece6f6a17.jpg 600w, https://basicagency.com/imager/uploads/case-studies/BB-Dakota/6473/BB-Dakota-Cover-Image-02_877de50699a08295026869680339ca47.jpg 940w, https://basicagency.com/imager/uploads/case-studies/BB-Dakota/6473/BB-Dakota-Cover-Image-02_fd86a370f71d27f380250b12fd5f1b14.jpg 1280w, https://basicagency.com/imager/uploads/case-studies/BB-Dakota/6473/BB-Dakota-Cover-Image-02_b0c80ca03ba713639113a0034ddf0313.jpg 2000w'
	}];
	
	var HomeSlider = function (_Component) {
	    _inherits(HomeSlider, _Component);
	
	    function HomeSlider(props) {
	        _classCallCheck(this, HomeSlider);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.tl = new _gsap.TimelineLite();
	
	        _this.handleResize = function () {
	            console.log('hello resize');
	            var tl = _this.tl,
	                carousel = _this.carousel;
	            var _this$state = _this.state,
	                active = _this$state.active,
	                ready = _this$state.ready,
	                carouselWidth = _this$state.carouselWidth,
	                windowWidth = _this$state.windowWidth;
	
	            var slides = carousel.children;
	            var image = carousel.children[0].children[0];
	
	            // Only fire if the images have loaded
	            if (!ready) return;
	            // Only fire if the window width changes, not the window height
	            if (windowWidth === window.innerWidth) return;
	            // Only fire if the carousel width changes (from Bootstrap's breakpoints)
	            if (carouselWidth === carousel.clientWidth) return;
	
	            // Move all slides except the active slide outside the visible area of the carousel
	            var filteredSlides = Array.from(slides).filter(function (item, index) {
	                return index !== active;
	            });
	            // Set width equal to the width of the inner carousel div
	            var width = carousel.clientWidth;
	            // Set height based on aspect ratio of original image dimensions
	            //const height = (image.naturalHeight / image.naturalWidth) * width;
	            var height = 10;
	
	            tl.set(filteredSlides, { x: width * 0.15 }).eventCallback('onComplete', _this.setState({
	                carouselHeight: parseInt(height),
	                carouselWidth: width,
	                windowWidth: window.innerWidth
	            }));
	        };
	
	        _this.handleLoad = function () {
	            console.log('hello load');
	            var tl = _this.tl,
	                carousel = _this.carousel,
	                next = _this.next;
	            var active = _this.state.active;
	
	            var slides = carousel.children;
	            var image = carousel.children[0].children[0];
	
	            // Move all slides except the active slide outside the visible area of the carousel
	            var filteredSlides = Array.from(slides).filter(function (item, index) {
	                return index !== active;
	            });
	            // Set width equal to the width of the inner carousel div
	            var width = carousel.clientWidth;
	            // Set height based on aspect ratio of original image dimensions
	            // const height = (image.naturalHeight / image.naturalWidth) * width;
	            var height = 10;
	
	            tl.set(filteredSlides, { x: -width * 0.15 }).to(slides[_this.state.next], 0.5, {
	                x: width * 0.25,
	                ease: _gsap.Power2.easeOut
	            });
	
	            tl.set(slides[active], { x: -width * 0.15 }).eventCallback('onComplete', function () {
	                return _this.setState({
	                    carouselHeight: parseInt(height),
	                    carouselWidth: width,
	                    windowWidth: window.innerWidth,
	                    ready: true
	                });
	            });
	        };
	
	        _this.handleNext = function () {
	            var tl = _this.tl,
	                carousel = _this.carousel;
	            var active = _this.state.active;
	
	            var slides = carousel.children;
	            var width = carousel.clientWidth;
	            var duration = 1;
	
	            if (tl.isActive()) return;
	
	            var current = active;
	
	            _this.setState({
	                moving: true
	            });
	
	            console.log("is moving from " + -width * 0.15 - 150 + " to " + -width, slides[current]);
	            tl.fromTo(slides[current], duration, { x: -width * 0.15 - 150 }, { x: -width, ease: _gsap.Expo.easeInOut }).set(slides[current], { x: width });
	
	            current = current === slides.length - 1 ? 0 : current + 1;
	            var next = current === slides.length - 1 ? 0 : current + 1;
	
	            console.log("is moving from " + width * 0.25 - 150 + " to " + -width * 0.15, slides[current]);
	
	            tl.fromTo(slides[current], duration, { x: width * 0.25 - 150 }, { x: -width * 0.15, opacity: 1, ease: _gsap.Expo.easeInOut }, '-=' + duration).eventCallback('onComplete', function () {
	                _this.setState({
	                    active: current,
	                    next: next,
	                    moving: false
	                });
	            });
	            _gsap.TweenMax.set(slides[next], {
	                x: width * 0.25
	            });
	
	            //let next = (current === (slides.length - 1)) ? 0 : current + 1;
	            //console.log('checkingnext', next, slides[next]);
	
	
	            console.log("is moving from " + width + " to " + width * 0.25, slides[next]);
	        };
	
	        _this.handleHover = function (e, index) {
	            console.log('Handle hober', index);
	            var tl = _this.tl,
	                carousel = _this.carousel;
	            var active = _this.state.active;
	
	            var slides = carousel.children;
	            var width = carousel.clientWidth;
	            var duration = 0.8;
	
	            if (tl.isActive()) return;
	
	            var current = active;
	            var next = current === slides.length - 1 ? 0 : current + 1;
	
	            if (_this.state.next === index) {
	                _this.setState({
	                    hoverMoving: true
	                });
	
	                _gsap.TweenLite.to(slides[next], 0.8, {
	                    x: width * 0.25 - 150,
	                    ease: _gsap.Power4.easeOut
	                });
	                _gsap.TweenLite.to(slides[current], 0.8, {
	                    x: -width * 0.15 - 150,
	                    ease: _gsap.Power4.easeOut
	
	                });
	            }
	
	            // else
	            //     TweenLite.to(slides[next], 0.5, {
	            //         x:width-280,
	            //         ease: Power2.easeOut,
	            //     })
	        };
	
	        _this.state = {
	            active: 0,
	            carouselWidth: 0,
	            carouselHeight: 0,
	            next: 1,
	            moving: false,
	            hoverMoving: false
	
	        };
	        return _this;
	    }
	
	    HomeSlider.prototype.onMouseLeaveHandle = function onMouseLeaveHandle(index) {
	        console.log('Handle hober');
	        var tl = this.tl,
	            carousel = this.carousel,
	            infoContainer = this.infoContainer;
	        var active = this.state.active;
	
	        var slides = carousel.children;
	        var width = carousel.clientWidth;
	        var duration = 1;
	        if (tl.isActive()) return;
	
	        var current = active;
	        var next = current === slides.length - 1 ? 0 : current + 1;
	
	        _gsap.TweenLite.to(slides[next], 0.5, {
	            x: width * 0.25,
	            ease: _gsap.Power2.easeOut
	        });
	        _gsap.TweenLite.to(slides[current], 0.5, {
	            x: -width * 0.15
	        });
	
	        this.setState({
	            hoverMoving: false
	        });
	    };
	
	    HomeSlider.prototype.sliderClickHandle = function sliderClickHandle(e, index) {
	        var active = this.state.active;
	        var tl = this.tl,
	            carousel = this.carousel;
	
	        var slides = carousel.children;
	        var next = active === slides.length - 1 ? 0 : active + 1;
	        console.log(index, active, next);
	        if (index === next) this.handleNext();
	    };
	
	    HomeSlider.prototype.componentDidMount = function componentDidMount() {
	        console.log('didmount');
	        window.addEventListener('load', this.handleLoad);
	        window.addEventListener('resize', this.handleResize);
	        var tl = this.tl,
	            carousel = this.carousel;
	
	        var slides = carousel.children;
	        var width = carousel.clientWidth;
	        _gsap.TweenLite.fromTo(slides[this.state.next], 0.5, {
	            x: width
	        }, {
	            x: width * 0.1,
	            ease: _gsap.Power2.easeOut
	        });
	
	        this.setState({
	            active: 0,
	            carouselWidth: 0,
	            carouselHeight: 0,
	            next: 1
	
	        });
	    };
	
	    HomeSlider.prototype.componentWillUnmount = function componentWillUnmount() {
	        console.log('hello cmunmount');
	        window.removeEventListener('load', this.handleLoad);
	        window.removeEventListener('resize', this.handleResize);
	    };
	
	    HomeSlider.prototype.render = function render() {
	        var _this2 = this,
	            _React$createElement;
	
	        var _state = this.state,
	            active = _state.active,
	            carouselHeight = _state.carouselHeight,
	            carouselWidth = _state.carouselWidth;
	        //let next = (active === (slides.length - 1)) ? 0 : active + 1;
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'featured-work-carousel', style: { position: 'relative' } },
	            _react2.default.createElement(
	                'div',
	                (_React$createElement = { className: 'featured-work-carousel__images ' }, _React$createElement['className'] = this.state.moving ? "featured-work-carousel__images feat--moving" : this.state.hoverMoving ? "featured-work-carousel__images feat-hoverMoving" : "featured-work-carousel__images", _React$createElement.style = { position: 'relative', overflow: 'hidden' }, _React$createElement.ref = function ref(carousel) {
	                    _this2.carousel = carousel;
	                }, _React$createElement),
	                this.props.posts.map(function (post, index) {
	                    return _react2.default.createElement(
	                        'div',
	                        { onMouseLeave: function onMouseLeave() {
	                                return _this2.onMouseLeaveHandle(index);
	                            }, onMouseEnter: function onMouseEnter(e) {
	                                return _this2.handleHover(e, index);
	                            }, onClick: function onClick(e) {
	                                return _this2.sliderClickHandle(e, index);
	                            }, className: active === index ? "featured-work-carousel__image cur-img-active " : index === _this2.state.next ? 'featured-work-carousel__image cur-next-slide' : 'featured-work-carousel__image', key: 'slide-' + index },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card card--featured-work' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'card--featured-work__image' },
	                                _react2.default.createElement('img', { src: post.node.featured_media.source_url, sizes: '100vw', style: { width: '100%' }, alt: '', className: 'layer bg' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card--featured-work--wrapper' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'bottomNext' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'rel-pos' },
	                                    _react2.default.createElement(
	                                        'h2',
	                                        null,
	                                        post.node.title
	                                    ),
	                                    _react2.default.createElement(
	                                        'h5',
	                                        null,
	                                        'NEXT'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'featured-word--slider--info-wrapper', style: { top: 0 } },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'container' },
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'featured-word--slider--info-container', ref: function ref(e) {
	                                                return _this2.infoContainer = e;
	                                            } },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'home-recent--project--details-wrap', style: { width: '100%', padding: '0 30px' } },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { ref: function ref(e) {
	                                                        return _this2.courDetails = e;
	                                                    } },
	                                                _react2.default.createElement('span', { className: 'home-recent--project--details--name', dangerouslySetInnerHTML: { __html: post.node.title } }),
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { className: 'home-recent--project--details--type' },
	                                                    post.node.categories[0].name
	                                                ),
	                                                _react2.default.createElement('span', { className: 'home-recent--project--details--para', dangerouslySetInnerHTML: { __html: post.node.excerpt.replace(/<\/?[^>]+(>|$)/g, "") } }),
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { style: { marginTop: '42px' } },
	                                                    _react2.default.createElement(_SGButton2.default, { title: 'SEE THIS POST', to: '/case-study/' + post.node.slug })
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    );
	                })
	            )
	        );
	    };
	
	    return HomeSlider;
	}(_react.Component);
	
	exports.default = HomeSlider;
	module.exports = exports['default'];

/***/ }),

/***/ 885:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gsap = __webpack_require__(39);
	
	var _ScrollMagic = __webpack_require__(23);
	
	var _ScrollMagic2 = _interopRequireDefault(_ScrollMagic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import ScrollMagicOne from '../../ScrollMagic';
	
	
	//require('animation.gsap');
	
	
	var introHeader = function (_Component) {
	    _inherits(introHeader, _Component);
	
	    function introHeader() {
	        _classCallCheck(this, introHeader);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    introHeader.prototype.componentDidMount = function componentDidMount() {
	        //let el = this.divStdHeaderBgWrap;
	        //let el1 = this.divHeroContent
	        //console.log(el);
	        // TweenMax.from(el, .8, {
	        //     autoAlpha: 0,
	        //     x: 0,
	        //     y: 50,
	        //     rotationX: -50,
	        //     transformOrigin: "center 0%",
	        //     ease: Back.easeOut
	        // }, "-=0.4");
	
	
	        // TweenMax.set(this.divHeroContent, {
	        //     perspective: 500
	        // });
	
	        // TweenMax.to(this.divHeroContent, 1, {
	        //     y: -200,
	        //     opacity: 0,
	        //     ease: Power1.easeOut
	        // }, "-=1");
	
	        _gsap.TweenMax.set(this.divStdHeaderBgWrap, {
	            transformPerspective: 1e3
	        });
	
	        _gsap.TweenMax.set(this.divHeroContent, {
	            perspective: 500
	        });
	
	        var i = new _gsap.TimelineMax();
	
	        i.set([this.divHeroListLineOne, this.divHeroListLineTwo], {
	            autoAlpha: 1
	        }).from(this.divHeroTitle, .8, {
	            autoAlpha: 0,
	            x: 0,
	            y: 50,
	            rotationX: -50,
	            transformOrigin: "center 0%",
	            delay: 2,
	            ease: _gsap.Back.easeOut
	        }, "-=0.4").from(this.divHeroListLineOne, .3, {
	            scaleX: 0,
	            y: 25,
	            ease: _gsap.Power2.easeOut,
	            transformOrigin: "center center"
	        }, "-=0.8").from(this.divHeroListLineTwo, .3, {
	            scaleX: 0,
	            y: -25,
	            ease: _gsap.Power2.easeOut,
	            transformOrigin: "center center"
	        }, "-=0.8").from(this.divHeroList, .6, {
	            y: 25,
	            autoAlpha: 0,
	            ease: _gsap.Power2.easeOut
	        }, "-=0.5").from(this.divStdHeaderBgWrap, 4, {
	            rotationX: 25,
	            autoAlpha: 0,
	            y: 0,
	            transformOrigin: "center 0%",
	            ease: _gsap.Power4.easeOut
	        }, "-=2.2");
	
	        //     var t = new TimelineLite;
	
	        //     t.to(this.divStdHeaderBgWrap, 1, {
	        //         scale: 1.5,
	        //         opacity: .1,
	        //         transformOrigin: "center center",
	        //         ease: Sine.easeInOut
	        //     }).to(this.divHeroContent, 1, {
	        //         y: -200,
	        //         opacity: 0,
	        //         ease: Power1.easeOut
	        //     }, "-=1");
	
	
	        //     var controller = new ScrollMagicOne.Controller({
	        //         globalSceneOptions: {
	
	        //         }
	        //       });
	
	
	        //       //console.log(t);
	
	        //    let sce = new ScrollMagicOne.Scene({
	        //         triggerElement: this.divHero,
	        //         triggerHook: 0,
	        //         duration: "100%"
	        //     });
	        //      sce.setTween(t).addTo(controller);
	    };
	
	    introHeader.prototype.render = function render() {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	            'section',
	            { className: 'hero', ref: function ref(e) {
	                    return _this2.divHero = e;
	                } },
	            _react2.default.createElement(
	                'div',
	                { className: 'hero__content', ref: function ref(e) {
	                        return _this2.divHeroContent = e;
	                    } },
	                _react2.default.createElement(
	                    'h1',
	                    { className: 'hero_title', ref: function ref(e) {
	                            return _this2.divHeroTitle = e;
	                        } },
	                    'A dynamic group of young creatives strongly driven by design. '
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'hero__list-wrap', ref: function ref(e) {
	                            return _this2.divHeroListWrap = e;
	                        } },
	                    _react2.default.createElement('div', { className: 'hero__list-line', ref: function ref(e) {
	                            return _this2.divHeroListLineOne = e;
	                        } }),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'hero__list', ref: function ref(e) {
	                                return _this2.divHeroList = e;
	                            } },
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'hero__list-item', ref: function ref(e) {
	                                    return _this2.divHeroListItem = e;
	                                } },
	                            'ARCHITECTURE'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'hero__list-item', ref: function ref(e) {
	                                    return _this2.divHeroListItem = e;
	                                } },
	                            'INTERIOR'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { className: 'hero__list-item', ref: function ref(e) {
	                                    return _this2.divHeroListItem = e;
	                                } },
	                            'Products'
	                        )
	                    ),
	                    _react2.default.createElement('div', { className: 'hero__list-line', ref: function ref(e) {
	                            return _this2.divHeroListLineTwo = e;
	                        } })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'std-header__bg-wrap', ref: function ref(e) {
	                        return _this2.divStdHeaderBgWrap = e;
	                    } },
	                _react2.default.createElement('img', { src: 'https://studiogritt.files.wordpress.com/2018/04/front.jpg', className: 'std-header__bg cover wp-post-image', alt: 'Studio Gritt Team' })
	            )
	        );
	    };
	
	    return introHeader;
	}(_react.Component);
	
	exports.default = introHeader;
	module.exports = exports['default'];

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(191);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A <Link /> is used an enhanced React Router Link. This Component
	 * will render a plain anchor tag when the Link is external. This
	 * Link will also prefetch anything in getComponent for a given route.
	 * This provides a smoother experience for the user.
	 *
	 */
	var Link = (_temp = _class = function (_Component) {
	  _inherits(Link, _Component);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        rest = _objectWithoutProperties(_props, ['children']);
	
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      rest,
	      children
	    );
	  };
	
	  return Link;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.node,
	  to: _propTypes2.default.string
	}, _temp);
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(888);
	
	var _Link = __webpack_require__(41);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SGButton = function (_Component) {
	    _inherits(SGButton, _Component);
	
	    function SGButton() {
	        _classCallCheck(this, SGButton);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    SGButton.prototype.render = function render() {
	        return _react2.default.createElement(
	            _Link2.default,
	            { to: this.props.to },
	            _react2.default.createElement(
	                'div',
	                { className: "sg-button" },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'sg-button--text' },
	                    this.props.title,
	                    ' '
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'sg-button--arrow' },
	                    _react2.default.createElement(
	                        'svg',
	                        { style: { width: '14px' }, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 24 12.7', className: '_2H5xozcs7D' },
	                        _react2.default.createElement('path', { 'class': 'arrow', d: 'M24 6.3L18 0l-1.3 1.5 3.6 3.9H0v2h20.3l-3.6 3.8 1.3 1.5 6-6.3z' })
	                    )
	                )
	            )
	        );
	    };
	
	    return SGButton;
	}(_react.Component);
	
	exports.default = SGButton;
	module.exports = exports['default'];

/***/ }),

/***/ 888:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	exports.default = Home;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Helmet = __webpack_require__(92);
	
	var _Helmet2 = _interopRequireDefault(_Helmet);
	
	var _Banner = __webpack_require__(371);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _Link = __webpack_require__(41);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _HomeFeatWorkWrapper = __webpack_require__(402);
	
	var _HomeFeatWorkWrapper2 = _interopRequireDefault(_HomeFeatWorkWrapper);
	
	var _IntroHeader = __webpack_require__(404);
	
	var _IntroHeader2 = _interopRequireDefault(_IntroHeader);
	
	var _HomeSlider = __webpack_require__(403);
	
	var _HomeSlider2 = _interopRequireDefault(_HomeSlider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import Content, { Col, Row } from 'components/Content'
	function Home(_ref) {
	  var data = _ref.data;
	
	
	  return _react2.default.createElement(
	    'main',
	    { className: 'maincontent' },
	    _react2.default.createElement(_Helmet2.default, {
	      title: 'Studio Gritt // Interiors / Architecture / Products',
	      description: 'Studio gritt is a multi-disciplinary design studio. A dynamic group of young creatives strongly driven by design.'
	    }),
	    _react2.default.createElement(_IntroHeader2.default, null),
	    _react2.default.createElement(
	      'section',
	      { className: 'cs-section cs-home home-recent--projects' },
	      _react2.default.createElement(
	        'div',
	        { className: 'cs-home-about--text' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Our design horizon is boundless and encompasses ',
	            _react2.default.createElement(
	              _Link2.default,
	              { to: '/architecture', className: 'homeText-Link-wrapper' },
	              _react2.default.createElement('span', { className: 'homeText-Link-container' }),
	              'Architecture'
	            ),
	            ', ',
	            _react2.default.createElement(
	              _Link2.default,
	              { to: '/interiors', className: 'homeText-Link-wrapper' },
	              _react2.default.createElement('span', { className: 'homeText-Link-container' }),
	              'Interiors'
	            ),
	            ' and ',
	            _react2.default.createElement(
	              _Link2.default,
	              { to: '/products', className: 'homeText-Link-wrapper' },
	              _react2.default.createElement('span', { className: 'homeText-Link-container' }),
	              'Products'
	            ),
	            '.'
	          )
	        )
	      ),
	      _react2.default.createElement(_HomeSlider2.default, { posts: data.allWordpressPost.edges.slice(0, 3) })
	    )
	  );
	}
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-1305f39e2a0b4e15018d.js